exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar[data-v-0b6ecce6]{display:inline-block;background-color:#000;color:#fff;width:48px;height:48px;font-size:12px;border-radius:50%;background-size:cover;background-position:50%;background-repeat:no-repeat;background-image:none}.avatar table[data-v-0b6ecce6]{width:100%;height:100%;text-align:center;vertical-align:middle;margin:0;padding:0}.avatar img[data-v-0b6ecce6]{width:100%;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b6ecce6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-avatar-component/Avatar.vue
// module id = 114
// module chunks = 0